import Accordion from "library/Atoms/Accordion";
import LoadGoogleMap from "library/GoogleMapComponents/LoadGoogleMap";
import CalculatePriceFormLayout from "pages/NewOrder/layouts/FormLayout/CalculatePriceFormLayout/CalculatePriceFormLayout";
import PropTypes from "prop-types";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { createMarkerPosition } from "utility/helpers/markers";
import useNewOrderMachine from "../../hooks/useNewOrderMachine";
import NewOrderDetails from "../NewOrderDetails/NewOrderDetails";
import NewOrderSubmitButtons from "../NewOrderSubmitButtons/NewOrderSubmitButtons";
import styles from "./CalculatePriceForm.styles";
import EstimatedDetails from "./EstimatedDetails/EstimatedDetails";
import NewOrderDirectionMap from "./NewOrderDirectionMap/NewOrderDirectionMap";

const CalculatePriceForm = ({ onReset }) => {
  const { t } = useTranslation();

  const [
    {
      order: { pick_up, drops },
      loading: isSubmitting,
    },
    ,
    { onSubmitStep },
  ] = useNewOrderMachine();

  const pickUpMarker = useMemo(() => {
    const { geolocation, location, postcode } = pick_up;
    const position = createMarkerPosition(geolocation);
    return position ? { position, location: `${location} | ${postcode}` } : null;
  }, [pick_up]);

  const dropMarkers = useMemo(() => {
    return drops.reduce((prev, { location, geolocation, postcode }) => {
      const position = createMarkerPosition(geolocation);
      return position ? [...prev, { position, location: `${location} | ${postcode}` }] : prev;
    }, []);
  }, [drops]);

  const mapBounds = useMemo(() => {
    return [pickUpMarker, ...dropMarkers].map(({ position }) => position);
  }, [pickUpMarker, dropMarkers]);

  return (
    <CalculatePriceFormLayout
      estimationDetailsSection={<EstimatedDetails />}
      orderDetailsSection={<NewOrderDetails />}
      mapSection={
        <Accordion
          id="new-order-map"
          className={styles.collapse}
          label={t("newOrder.forms.calculatePriceForm.shopMapBtn")}
          asyncMount
        >
          <LoadGoogleMap>
            <NewOrderDirectionMap
              className={styles.map}
              bounds={mapBounds}
              pickUpMarker={pickUpMarker}
              dropMarkers={dropMarkers}
            />
          </LoadGoogleMap>
        </Accordion>
      }
      controlsSection={
        <NewOrderSubmitButtons
          onSubmit={() => onSubmitStep()}
          onReset={onReset}
          submitBtnOptions={{ loading: isSubmitting }}
        />
      }
    />
  );
};

CalculatePriceForm.propTypes = {
  onReset: PropTypes.func.isRequired,
};

export default CalculatePriceForm;
